import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseDialog from "../ui/BaseDialog";
import ActionButton from "../ui/ActionButton";

// logout modal confirmation
const LogoutModal = ({ open, onClose, onConfirm, darkMode }) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={t("Confirm Logout")}
      darkMode={darkMode}
      ariaLabelledBy="logout-modal-title"
      ariaDescribedBy="logout-modal-description"
      actions={
        <>
          <ActionButton onClick={onClose} variant="default" modal>
            {t("Cancel")}
          </ActionButton>
          <ActionButton onClick={onConfirm} variant="danger" modal>
            {t("Logout")}
          </ActionButton>
        </>
      }
    >
      {/* message */}
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "1rem",
          color: darkMode ? "#e0e0e0" : "#666666",
          textAlign: "center",
        }}
      >
        {t("Are you sure you want to logout?")}
      </Typography>
    </BaseDialog>
  );
};

LogoutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default LogoutModal;